export default __webpack_public_path__ + "static/media/envelopeIcon.8138b886.svg";